<template>
  <div class="gl-for-mngt-commentary" data-testid="gl-for-mngt-commentary">
    <div loader-height="2" class="shadow-off pa-6 gl-for-mngt-commentary__shell" :loading="loading || isDataSavingloading"
      :disabled="loading || isDataSavingloading">
      <div class="d-flex flex-column gap-4 gl-for-mngt-commentary__stack">
        <!-- Title -->
        <div class="d-flex align-center">
          <PageHeader 
            :title="'GL & Drill-down Selection'"
            :loading="loading"
            @refresh="refreshData"
          />
          <v-spacer/>
          <CountToolbar :pendingRequestCount="pendingRequestList.length" @get-pending-requests="handlePendingRequests"
            @show-faq="faqdialog = true" @refresh="refreshData" />
        </div>

        <div v-if="data.length > 0 || loading" class="d-flex flex-column">
          
          <GlselectionFilter
            :selectednetwork.sync="selectednetwork"
            :data="data"
            :cycletype.sync="cycletype"
            :cycletypeList="cycletypeList"
            :selectedPeriodToGet.sync="selectedPeriodToGet"
            :selectedPeriodToGetDefult="selectedPeriodToGetDefult"
            :minDate="minDate"
            class="mb-6"
          />

          <div class="d-flex align-center gap-2 gl-for-mngt-commentary__tabs" data-testid="gl-for-mngt-commentary__tabs">
            <div
              class="folder-tab"
              :class="{ active: activeStatementTab === statementTabIndex.BALANCE_SHEET }"
              @click="handleStatementTabSelection(statementTabIndex.BALANCE_SHEET)"
              data-testid="gl-for-mngt-commentary__tab-balance-sheet"
            >
              Balance Sheet
            </div>
            <div
              class="folder-tab"
              :class="{ active: activeStatementTab === statementTabIndex.PROFIT_AND_LOSS }"
              @click="handleStatementTabSelection(statementTabIndex.PROFIT_AND_LOSS)"
              data-testid="gl-for-mngt-commentary__tab-profit-loss"
            >
              Profit & Loss
            </div>
          </div>
          <v-card class="pa-3 d-flex flex-column gap-4" style="border-radius: 10px; border-top-left-radius: 0; border-left: 1px solid #E5E5E5; border-right: 1px solid #E5E5E5; border-bottom: 1px solid #E5E5E5; box-shadow: none !important;" data-testid="gl-for-mngt-commentary__content-card">
            <GlSelectActions  :slCount="selectedsls.length"
              :glCount="selectedgls.length"
              @select-all="selectAll"
              @unselect-all="unSelectAll"
              @save="handleSave"
              :selectedgls="selectedgls"
              :selectedsls="selectedsls"
              :savedGlsStatus="savedGlsStatus"
              :savedSlsStatus="savedSlsStatus"
              :data="data"
              :saving="isDataSavingloading"
            />
            <GlSelectionTable 
              :loading="loading"
              :headers="glSelectionHeaders"
              :visible-items="visibleItems"
              :selectedgls.sync="selectedgls"
              :selectedsls.sync="selectedsls"
              :saved-gls-status="savedGlsStatus"
              :saved-sls-status="savedSlsStatus"
              :expanded-ids="expandedIds"
              :gl-label="$nova.labelsName('gl_selection', 'commentary_gl_shortform_label', 'GL')"
              :ungrouped-items="ungroupedGlItems"
              @toggle-expand="toggleExpand"
            />
          </v-card>
        </div>
        <div v-else class="title grey--text pa-5 text-center noTransform">
          {{ message || 'No Data Found' }}
        </div>
      </div>
    </div>

    <v-dialog v-if="addeditdialog" v-model="addeditdialog" max-width="800" persistent>
      <v-card :loading="addeditloading" :disabled="addeditloading" loader-height="2" class="">
        <v-card-text class="primary white--text d-flex align-center py-2 px-4">
          <span class="font-size-md white--text">Select GL's</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="addeditdialog = false" class="ml-2 white--text"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-text>
        <v-card-text class="pt-4 pb-2">
          <div class="font-size-md font-weight-bold">{{ addeditdata.name }}</div>
          <div>Un-select the Gl's for which commentary is not required under this network</div>
        </v-card-text>
        <v-card-text class="transition-list">
          <div class="mb-1 d-flex">
            <v-btn @click="selectAll()" outlined class="mr-1"><v-icon class="mr-1">mdi-checkbox-marked</v-icon>
              <span>Select All</span></v-btn>
            <v-btn @click="unSelectAll()" outlined><v-icon class="mr-1">mdi-checkbox-blank-outline</v-icon>
              <span>Un-select All</span></v-btn>
          </div>
          <perfect-scrollbar style="max-height: 55vh">
            <div v-for="(v, k) in gllist['parent'] || []" :key="k">
              <div class="cursor-pointer hoverable">
                <div class="d-flex align-center py-1" @click="expandColapseList(v.code)">
                  <v-checkbox label="" dense class="my-0 pt-0 mx-2" @click.stop hide-details v-model="selectedgls"
                    :value="v.code"></v-checkbox>
                  <span class="font-weight-bold">{{ v.code }}</span>
                  <v-icon>mdi-circle-small</v-icon>
                  <span class="font-weight-bold">{{ v.name }}</span>
                  <span v-if="(gllist[v.code] || []).length > 0">
                    <v-icon class="ml-2" v-if="expandedgls.indexOf(v.code) > -1">mdi-chevron-down</v-icon>
                    <v-icon class="ml-2" v-else>mdi-chevron-right</v-icon>
                  </span>
                  <v-spacer></v-spacer>
                  <v-chip v-if="(gllist[v.code] || []).length > 0" label color="caccounting"
                    class="white--text px-2"><v-chip small color="white" class="mr-2 px-2">{{ (gllist[v.code] ||
                      []).length }}</v-chip>GL's</v-chip>
                </div>
                <div v-if="expandedgls.indexOf(v.code) > -1">
                  <div v-for="(sv, sk) in gllist[v.code] || []" :key="sk" class="ml-4">
                    <div class="cursor-pointer hoverable">
                      <div class="d-flex align-center">
                        <v-checkbox label="" dense class="my-0 pt-0 mx-2" hide-details v-model="selectedgls"
                          :value="sv.code"></v-checkbox>
                        <span class="font-weight-bold">{{ sv.code }}</span>
                        <v-icon>mdi-circle-small</v-icon>
                        <span>{{ sv.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <v-divider></v-divider>
            </div>
          </perfect-scrollbar>
        </v-card-text>
        <v-card-text>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveData(addeditdata._id)"><v-icon
                class="mr-1">mdi-content-save</v-icon><span>Save</span></v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <lb-dialog v-if="pendingRequestDialog" v-model="pendingRequestDialog" heading="Pending Approval List" width="80%"
      :loading="isPendingRequestLoading">
      <template v-slot:body>
        <div>
          <IndividualApprovalsList :data="pendingRequestList" :custom-headers='pendingRequestHeaders' :key="new Date().getTime()"
              />
        </div>
      </template>
    </lb-dialog>

    <lb-drawer v-if="faqdialog" v-model="faqdialog"
      @input="$emit('input', $event)"
      heading="Frequently Asked Question"
      Maxwidth="50%"
      :loading="loading"
      :sidePeekDefault="true"
      :hideMenu="true"
      data-testid="materiality-faq__drawer">
      <template v-slot:body>
        <div class="d-flex flex-column gap-2">
          <h6 class="font-weight-medium noTransform">
            What is {{ $nova.labelsName('access_management', 'commentary_gl_selection_label_menu', 'GL Selection') }}?
            How can I update this?
          </h6>

          <span class="noTransform faqAnswer">
            {{ $nova.labelsName('access_management', 'commentary_gl_selection_label_menu', 'GL Selection') }}
            involves selecting account codes by the Tool Admin Preparer for which the defined
            materiality limits will be applied and commentary submission is required.
            <br><br>
            If certain account codes are not selected, users are not required to submit or approve
            commentary against variances for those account codes. However, these account codes will
            still be visible in the application against the
            {{ $nova.labelsName('my_reporting_units_page', 'ru_entity_label', 'Reporting Unit') }},
            but they will not be flagged for commentary submission.
            <br><br>
            For a detailed explanation and step-by-step instructions, please refer to the
            "GL Selection" section in the User Manual.
          </span>
        </div>

        <br>

        <div class="d-flex flex-column gap-2">
          <h6 class="font-weight-medium noTransform">
            How can a user waive the commentary requirement for specific GL line items?
          </h6>

          <div class="noTransform faqAnswer">
            <ol>
              <li>
                {{ $nova.labelsName('access_management', 'commentary_gl_selection_label_menu', 'GL Selection') }}
                is performed at the Network level. Therefore, immaterial GL codes can be excluded
                by the Tool Admin Preparer.
              </li>
              <li>
                If a GL code is selected and exceeds the defined materiality threshold,
                commentary must be provided.
              </li>
              <li>
                If the GL codes continue to appear on the dashboard requiring commentary despite
                the above steps, please contact the Consark Support Team with issue details and a
                screenshot (if available).
              </li>
            </ol>
          </div>
        </div>
      </template>
    </lb-drawer>

    <v-dialog v-if="selectedPeriodDialog" v-model="selectedPeriodDialog"
      :heading="isUpdate === true ? 'Select Period to Update' : 'Select Period to Get'" max-width="290px"
      transition="dialog-transition"
      persistent>
      <div>
        <v-card :loading="isDataSavingloading" :disabled="isDataSavingloading">
          <v-card-text class="pa-0">
            <v-date-picker elevation="0" v-model="selectedPeriodToUpdate" color="primary" show-adjacent-months
              :multiple="isUpdate" type="month" :min="minDate" :max="selectedPeriodToGetDefult" :disabled="isDataSavingloading">
              <v-spacer></v-spacer>
              <v-btn text @click="selectedPeriodDialog = false" :disabled="isDataSavingloading"><span>Close</span></v-btn>
              <v-btn elevation="0" color="primary" v-if="isUpdate && selectedPeriodToUpdate.length > 0"
                @click="confirmSaveDialog = true" :loading="isDataSavingloading" :disabled="isDataSavingloading"><span>Update</span></v-btn>
              <v-btn elevation="0" color="primary" @click="saveData(addeditdata._id)"
                v-if="!isUpdate && selectedPeriodToGet !== ''" :loading="isDataSavingloading" :disabled="isDataSavingloading"><span>Get</span></v-btn>
            </v-date-picker>
          </v-card-text>
        </v-card>
      </div>
      <!-- <lb-selectmultiplemonths v-if="isUpdate" type="month" hidedetails v-model="selectedPeriod" label="Applicable Periods"
              id="applicable-periods " class='ml-1'  :value="selectedPeriod || []" :key="new Date().getTime()"/>
              <lb-date v-else type="month" hidedetails v-model="selectedPeriod" label="Period" class="ml-5" :defaultdialogopen="true" :key="new Date().getTime()+'dialog'" /> -->
    </v-dialog>

    <GlTabWarningDialog
      v-model="unsavedChangesDialog"
      @confirm="confirmTabSwitch"
      @cancel="cancelTabSwitch"
      data-testid="gl-for-mngt-commentary__unsaved-warning"
    />

    <lb-dialog v-model="confirmSaveDialog" v-if="confirmSaveDialog" heading="Confirm Save" width="45%" data-testid="gl-for-mngt-commentary__confirm-save-dialog">
      <template v-slot:body>
        <div class="d-flex flex-column gap-4 pa-4" data-testid="gl-confirm-save-dialog__body">
          <div class="d-flex gap-2">
            <div class="d-flex flex-column gap-2">
              <h5 class="font-weight-medium" data-testid="gl-confirm-save-dialog__message">
                You are about to save changes. Please ensure all selections are accurate before proceeding.
              </h5>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="d-flex justify-end gap-2">
          <v-btn outlined color="primary" elevation="0" @click="confirmSaveDialog = false" :disabled="isDataSavingloading" data-testid="gl-confirm-save-dialog__cancel-btn">
            Cancel
          </v-btn>
          <v-btn color="primary" elevation="0" @click="handleConfirmSave" :loading="isDataSavingloading" :disabled="isDataSavingloading" data-testid="gl-confirm-save-dialog__confirm-btn">
            Confirm
          </v-btn>
        </div>
      </template>
    </lb-dialog>
  </div>
</template>

<script>
// import SubGlItemList from "../../varianceanalysis/views/SubGlItemList.vue"
import IndividualApprovalsList from "./IndividualApprovalsList.vue";
// import CountActions from "./GlSelection/CountActions.vue";
import GlselectionFilter from "./GlSelection/GlSelectionFilter.vue";
import GlSelectActions from "./GlSelection/GlSelectActions.vue";
import GlSelectionTable from "./GlSelection/GlSelectionTable.vue";
import CountToolbar from './GlSelection/CountToolbar.vue';
import { STATEMENT_TABS, STATEMENT_TAB_INDEX, STATEMENT_TYPES, GL_SELECTION_HEADERS, PENDING_REQUEST_HEADERS } from '../utils/constants';
import { mapActions } from "vuex";
import PageHeader from '../components/PageHeader.vue';
import GlTabWarningDialog from '../components/GlTabWarningDialog.vue';

export default {
  name: 'GLforMngtCommentary',
  data: function () {
    return {
      pagename: "gl_selection",
      loading: false,
      data: [],
      activeStatementTab: STATEMENT_TAB_INDEX.PROFIT_AND_LOSS,
      statementType: STATEMENT_TABS[STATEMENT_TAB_INDEX.PROFIT_AND_LOSS].value,
      cycletypeList: [{ name: this.$nova.labelsName('materiality_page', 'actual_label', 'Actual'), value: 'actual' }, { name: this.$nova.labelsName('materiality_page', 'forecast_longform_label', 'Forecast'), value: 'forecast' }],
      newdata: [],
      allgls: [],
      // parentglslist: [],
      expandedgls: [],
      gllist: {},
      enableslot: ["name"],
      selectedgls: [],
      selectedsls: [],
      savedGlsStatus: [],
      savedSlsStatus: [],
      subglitems: [],
      searchtext: "",
      multiselectkey: "_id",
      addeditdialog: false,
      addeditloading: false,
      addeditdata: {},
      selectednetwork: "",
      cycletype: "actual",
      headers: [
        {
          value: "code",
          text: "Code",
          sortable: false,
          filterable: true,
          lock: true,
          visible: false,
        },
        {
          value: "name",
          text: "Name",
          sortable: false,
          filterable: true,
          lock: true,
          visible: false,
        },

      ],
     glSelectionHeaders: GL_SELECTION_HEADERS,
      pagecount: 2,
      page: 2,
      pageItems: [],
      pendingRequestDialog: false,
      pendingRequestList: [],
      isPendingRequestLoading: false,
      message: '',
      faqdialog: false,
      pendingRequestHeaders: PENDING_REQUEST_HEADERS,
      isNewList: false,
      selectedPeriodToUpdate: [],
      selectedPeriodToGet: '',
      selectedPeriodDialog: false,
      isUpdate: false,
      minDate: '2023-01',
      maxDate: '',
      minDateToReadData: '',
      fydetails: { 'start': '01', 'end': '12' },
      isDataSavingloading: false,
      expandedIds: [],
      getResult: [],
      selectedPeriodToGetDefult: '',
      // Flag to prevent watcher from triggering during initial data load
      isInitialDataLoad: false,
      // Tab-specific selections storage - keeps BS and PL selections separate
      tabSelections: {
        bs: { gls: [], sls: [], savedGls: [], savedSls: [] },
        pl: { gls: [], sls: [], savedGls: [], savedSls: [] }
      },
      unsavedChangesDialog: false,
      pendingTabIndex: null,
      confirmSaveDialog: false,
    }
  },
  activated() {
    this.refreshData();
  },
  mounted() {
    this.refreshData();
  },
  components: {
    PageHeader,
    // SubGlItemList,
    IndividualApprovalsList,
    // CountActions,
    GlselectionFilter,
    GlSelectActions,
    GlSelectionTable,
    CountToolbar,
    GlTabWarningDialog
  },
  beforeDestroy() {
    this.resetViewState();
  },
  methods: {
    ...mapActions('varianceanalysis', {
      getNetworkDetails: 'getNetworkDetails',
      getGlList: 'getGlList',
      saveApprovalsRequest: 'saveApprovalsRequest',
      fetchPendingRequests: 'getPendingRequests'
    }),
    handleStatementTabSelection(tabIndex) {
      if (this.activeStatementTab === tabIndex) {
        return;
      }
      
      // Check for unsaved changes before switching
      if (this.hasUnsavedChanges()) {
        this.pendingTabIndex = tabIndex;
        this.unsavedChangesDialog = true;
        return;
      }
      
      // No unsaved changes, proceed with switch
      this.proceedTabSwitch(tabIndex);
    },
    
    hasUnsavedChanges() {
      const currentGls = [...this.selectedgls].sort();
      const savedGls = [...this.savedGlsStatus].sort();
      const currentSls = [...this.selectedsls].sort();
      const savedSls = [...this.savedSlsStatus].sort();
      return JSON.stringify(currentGls) !== JSON.stringify(savedGls) ||
             JSON.stringify(currentSls) !== JSON.stringify(savedSls);
    },
    
    confirmTabSwitch() {
      const pendingTab = this.pendingTabIndex;
      this.pendingTabIndex = null;
      this.unsavedChangesDialog = false;
      if (pendingTab !== null) {
        this.selectedgls = [...this.savedGlsStatus];
        this.selectedsls = [...this.savedSlsStatus];
        this.saveCurrentTabSelections();
        this.activeStatementTab = pendingTab;
      }
    },
    
    cancelTabSwitch() {
      this.pendingTabIndex = null;
      this.unsavedChangesDialog = false;
    },
    
    proceedTabSwitch(tabIndex) {
      // Save current tab selections before switching
      const currentTabKey = this.getCurrentTabKey();
      console.log(`[GLforMngtCommentary] Switching from ${currentTabKey} to ${tabIndex === STATEMENT_TAB_INDEX.BALANCE_SHEET ? 'bs' : 'pl'}`);
      console.log(`[GLforMngtCommentary] Saving ${currentTabKey} selections: GLs=${this.selectedgls.length}, SLs=${this.selectedsls.length}`);
      this.saveCurrentTabSelections();
      
      // Switch to the new tab
      this.activeStatementTab = tabIndex;
    },
    
    // Get the current tab key for tabSelections storage
    getCurrentTabKey() {
      return this.activeStatementTab === STATEMENT_TAB_INDEX.BALANCE_SHEET ? 'bs' : 'pl';
    },
    
    // Save current selections to tab-specific storage
    saveCurrentTabSelections() {
      const tabKey = this.getCurrentTabKey();
      this.tabSelections[tabKey].gls = [...this.selectedgls];
      this.tabSelections[tabKey].sls = [...this.selectedsls];
      console.log(`[GLforMngtCommentary] Saved to tabSelections.${tabKey}: GLs=${this.tabSelections[tabKey].gls.length}`);
    },
    
    // Restore selections from tab-specific storage  
    restoreTabSelections(tabKey) {
      this.selectedgls = [...this.tabSelections[tabKey].gls];
      this.selectedsls = [...this.tabSelections[tabKey].sls];
      this.savedGlsStatus = [...this.tabSelections[tabKey].savedGls];
      this.savedSlsStatus = [...this.tabSelections[tabKey].savedSls];
      console.log(`[GLforMngtCommentary] Restored from tabSelections.${tabKey}: GLs=${this.selectedgls.length}`);
    },
    
    // Update saved status for current tab (after API data loads)
    updateTabSavedStatus(gls, sls) {
      const tabKey = this.getCurrentTabKey();
      this.tabSelections[tabKey].savedGls = [...gls];
      this.tabSelections[tabKey].savedSls = [...sls];
      this.tabSelections[tabKey].gls = [...gls];
      this.tabSelections[tabKey].sls = [...sls];
      console.log(`[GLforMngtCommentary] Updated tabSelections.${tabKey} from API: GLs=${gls.length}, SLs=${sls.length}`);
    },
    
    // Reset all tab selections (e.g., when network changes)
    resetAllTabSelections() {
      this.tabSelections = {
        bs: { gls: [], sls: [], savedGls: [], savedSls: [] },
        pl: { gls: [], sls: [], savedGls: [], savedSls: [] }
      };
      console.log('[GLforMngtCommentary] Reset all tab selections');
    },
    // Trigger data reload when the statement tab changes
    handleStatementTypeChange(nextType) {
      this.statementType = nextType;
      const effectivePeriod = this.selectedPeriodToGet || this.selectedPeriodToGetDefult || new Date();
      if (this.selectednetwork) {
        this.changesPeriodDate(this.selectednetwork, this.cycletype, effectivePeriod);
      } else {
        this.refreshData();
      }
    },
    // Reset view-specific state before component teardown
    resetViewState() {
      this.activeStatementTab = STATEMENT_TAB_INDEX.PROFIT_AND_LOSS;
      this.statementType = STATEMENT_TYPES.PROFIT_AND_LOSS;
    },
     handlePendingRequests() {
      this.pendingRequestDialog = true;
      this.getPendingRequests();
    },
    handleSave(){
      this.selectedPeriodToUpdate = [];
      this.selectedPeriodDialog = true;
      this.isUpdate = true;
    },
    async handleConfirmSave() {
      await this.saveData(this.addeditdata._id);
    },
    flattenTree() {
      let result = [];
      
      // Helper for DFS traversal
      const traverse = (nodeList, level) => {
        if (!nodeList || nodeList.length === 0) return;
        
        // Sort siblings by order
        const sorted = [...nodeList].sort((a, b) => a.order - b.order);
        
        for (const node of sorted) {
          // Process node
          const createdAt = new Date(node.created_at);
          const now = new Date();
          const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);
          const isGlnew = diffDays <= 60;
          
          // Handle ungrouped offset logic
          if ((node.parent === "NA" || node?.path?.includes("NA")) && node?.order < this.$constants.UNGROUPED_GL_OFFSET) {
             node.oldOrder = node?.order;
             node.order += this.$constants.UNGROUPED_GL_OFFSET;
          }

          const processedNode = {
            ...node,
            level: level,
            glnew: isGlnew
          };
          
          result.push(processedNode);
          
          // Initialize expandedIds for roots
          const isRoot = node.parent === "primary" || node.parent === null;
          if (isRoot && !this.expandedIds.includes(node.code)) {
             this.expandedIds.push(node.code);
          }

          // Recurse for children
          if (this.gllist[node.code]) {
            traverse(this.gllist[node.code], level + 1);
          }
        }
      };

      // 1. Process Primary Tree
      traverse(this.gllist['primary'] || [], 0);
      
      // 2. Process Ungrouped (NA)
      const naNodes = this.gllist['NA'] || [];
      if (naNodes.length > 0) {
          // Collect all descendant codes for NA node
          let ungroupedGLs = [];
          let ungroupedGLsChildren = [];
          
          // Helper to collect codes
          const collectCodes = (list) => {
              for(const n of list) {
                  ungroupedGLs.push(n.code);
                  ungroupedGLsChildren.push(n.code, ...(n.children || []));
                  if (this.gllist[n.code]) {
                      collectCodes(this.gllist[n.code]);
                  }
              }
          }
          collectCodes(naNodes);
          
          let NANode = {
            name: "Ungrouped: Other sub-schedules and further Analysis Accounts",
            code: "NA",
            children: ungroupedGLs,
            subsequent_children: ungroupedGLsChildren,
            order: this.$constants.UNGROUPED_GL_OFFSET,
            level: 0,
            glnew: false
          };
          
          result.push(NANode);
          if (!this.expandedIds.includes("NA")) {
             this.expandedIds.push("NA");
          }
          
          // Traverse NA children
          traverse(naNodes, 1);
      }
      
      return result;
    },
    toggleExpand(item) {
      if (!this.hasChildren(item)) return;
      let childarray = item.children;
      let subchild = item.subsequent_children;
      if (this.expandedIds.includes(childarray[0])) {
        this.expandedIds = this.expandedIds.filter(
          (id) => !subchild.includes(id)
        );
      } else {
        this.expandedIds.push(...childarray);
      }
    },
    hasChildren(item) {
      return item?.children?.length;
    },
    isExpanded(item) {
      let childarray = item.children;
      return this.expandedIds.includes(childarray[0]);
    },
    refreshData() {
      //this.getData();
      const today = new Date();
      console.log("date", today.getMonth())
      if (today.getMonth() > this.fydetails.end) {
        this.maxDate = (today.getFullYear() + 1) + "-" + this.fydetails.end;
      }
      else if (today.getMonth() < this.fydetails.end) {
        this.maxDate = (today.getFullYear()) + "-" + this.fydetails.end;
      }
      this.selectedPeriodToGet = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
      this.selectedPeriodToGetDefult = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
      Promise.all([this.getData(), this.getPendingRequests()])

    },
    async getData() {
      try {
        this.loading = true;
        this.isInitialDataLoad = true; // Prevent watcher from triggering
        this.selectednetwork = "";
        this.addeditdata = {};
        this.selectedgls = [];
        this.selectedsls = [];

        const period = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`;
        const response = await this.getNetworkDetails({
          axios: this.axios,
          payload: { data: { period, statementtype: this.statementType } }
        });

        if (response.data.status !== "success") {
          throw new Error(response.data.message || "Error reading data");
        }

        this.data = response.data.data || [];
        if (this.data.length === 0) {
          this.message = "No Data Found";
          return { data: { status: 'success', data: [] } };
        }

        this.message = response.data.message || "No Data Found";
        // Set selectednetwork - watcher won't fire due to isInitialDataLoad flag
        this.selectednetwork = this.data[0]?._id || "";

        // Run both API calls in parallel since they don't depend on each other
        const [networkDetails, glListResponse] = await Promise.all([
          this.getNetworkDetails({
            axios: this.axios,
            payload: { data: { period, network: this.selectednetwork, cycletype: this.cycletype, statementtype: this.statementType } }
          }),
          this.getGlList({ axios: this.axios, payload: { reporting_type: this.statementType } })
        ]);

        this.addeditdata = networkDetails.data.data[0] || {};
        if (!this.addeditdata || Object.keys(this.addeditdata).length === 0) {
          this.message = "No Data Found";
          console.log(this.addeditdata, "No Data Found");

          return { data: { status: 'success', data: [] } };
        }

        this.selectedgls = this.cycletype === "actual"
          ? this.addeditdata.gls_actual || []
          : this.cycletype === "forecast"
            ? this.addeditdata.gls_forecast || []
            : [];

        this.selectedsls = this.cycletype === "actual"
          ? this.addeditdata.sls_actual || []
          : this.cycletype === "forecast"
            ? this.addeditdata.sls_forecast || []
            : [];

        // Set saved status from API data
        this.savedGlsStatus = [...this.selectedgls];
        this.savedSlsStatus = [...this.selectedsls];
        
        // Reset all tab selections and update current tab storage
        this.resetAllTabSelections();
        this.updateTabSavedStatus(this.selectedgls, this.selectedsls);

        // Process GL list response
        if (glListResponse.data.status === "success" && glListResponse.data.data.length > 0) {
          this.gllist = {};
          this.getResult = glListResponse.data.data;
          this.setDisplayList(glListResponse.data.data);
        } else {
          throw new Error(glListResponse.data.message || "Error reading GL list data");
        }

      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      } finally {
        this.loading = false;
        this.isInitialDataLoad = false; // Re-enable watcher after initial load completes
      }
    },
    
    async getPendingRequests() {
      console.log(this.gllist)
      this.isPendingRequestLoading = true;
      try {
        const dt = await this.fetchPendingRequests({ axios: this.axios });
        if (dt.data.status === 'success') {
          this.pendingRequestList = dt.data.data || []
        }
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      } finally {
        this.isPendingRequestLoading = false;
      }
    },
    setDisplayList(d) {
      this.gllist = {};
      let allgllist = []
      let key = -1;
      for (const i of (d || [])) {
        key++;
        i.__key = key;
        allgllist.push(i.code);
        i['isnewgl'] = false;
        if ((new Date() - new Date(i.created_at)) / (1000 * 60 * 60 * 24) <= 60) {
          i['isnewgl'] = true
        }
        if (i.parent) {
          this.gllist[i.parent] = this.gllist[i.parent] || [];
          this.gllist[i.parent].push(i);  // i['isnewgl'] will be false here
        } else {
          this.gllist["NA"] = this.gllist["NA"] || [];
          this.gllist["NA"].push(i);
        }

        // Check if the record was created within the last 60 days

      }
      this.gllist["primary"] = this.reorder(this.gllist["primary"] || [], 'order');
      this.gllist["NA"] = this.reorder(this.gllist["NA"] || [], 'order');
      // this.gllist["new"] = this.reorder(this.gllist["new"] || [], 'order');
      for (const i of this.gllist['primary']) {
        this.gllist[i.code] = this.reorder(this.gllist[i.code] || [], 'order');
      }
      // if((d || []).length === this.gllist['new'].length){
      //   this.isNewList = true;
      // }
      this.allgls = allgllist;
    },
    reorder(dt, key) {
      return dt.sort(function (a, b) { return a[key] - b[key]; });
    },

    async saveData(id) {
      if (!this.selectedgls.length > 0) {
        return this.$store.commit("sbError", "GL Selection Not Selected");
      }
      this.isDataSavingloading = true;
      let gls_actual_detail = [];
      let sls_actual_detail = [];
      // Don't close dialog here - wait for API response
      try {
        if (!id) throw new Error('Please select network')
        for (const gl of this.selectedgls) {
          gls_actual_detail.push({ code: this.gllist[gl] })
        }
        for (const sl of this.selectedsls) {
          sls_actual_detail.push({ codesl: this.gllist[sl] })
        }

        // Build payload - SL selection is optional
        let dta = { gls_actual: this.selectedgls.filter(item => item !== null) };
        if (this.selectedsls && this.selectedsls.length > 0) {
          dta.sls_actual = this.selectedsls.filter(item => item !== null);
        }
        if (this.cycletype === "forecast") {
          dta = { gls_forecast: this.selectedgls.filter(item => item !== null) };
          if (this.selectedsls && this.selectedsls.length > 0) {
            dta.sls_forecast = this.selectedsls.filter(item => item !== null);
          }
        }

        // Calculate affected_gls
        const originalGLs = this.savedGlsStatus || [];
        const currentGLs = this.selectedgls.filter(item => item !== null);
        const addedGLs = currentGLs.filter(x => !originalGLs.includes(x));
        const removedGLs = originalGLs.filter(x => !currentGLs.includes(x));

        const originalSLs = this.savedSlsStatus || [];
        const currentSLs = this.selectedsls ? this.selectedsls.filter(item => item !== null) : [];
        const addedSLs = currentSLs.filter(x => !originalSLs.includes(x));
        const removedSLs = originalSLs.filter(x => !currentSLs.includes(x));

        let affected_gls = [...addedGLs, ...removedGLs, ...addedSLs, ...removedSLs];

        // Debug logging for save payload
        const currentTab = this.getCurrentTabKey();
        console.log(`[GLforMngtCommentary] Save called on tab: ${currentTab}`);
        console.log(`[GLforMngtCommentary] selectedgls count: ${this.selectedgls.length}`, this.selectedgls);
        console.log(`[GLforMngtCommentary] savedGlsStatus count: ${originalGLs.length}`);
        console.log(`[GLforMngtCommentary] affected_gls count: ${affected_gls.length}`, affected_gls);
        console.log(`[GLforMngtCommentary] Payload:`, dta);

        const dt = await this.saveApprovalsRequest({
          axios: this.axios,
          id: id,
          payload: { data: [dta], period: this.selectedPeriodToUpdate, reporting_type: this.statementType, affected_gls: affected_gls }
        });

        if (dt.data.status === "success") {
          this.$store.commit("sbSuccess", "GL Selection change request sent");
          this.addeditdialog = false;
          this.selectedPeriodDialog = false;
          this.confirmSaveDialog = false;
          this.selectedPeriodToUpdate = [];
          
          if (this.selectednetwork) {
            await this.changesPeriodDate(this.selectednetwork, this.cycletype, this.selectedPeriodToGet);
          } else {
            await this.refreshData();
          }
          await this.getPendingRequests();
        } else throw dt.data.message || "error updating gl list";

      } catch (error) {
        // this.loading = false;
        this.$store.commit("sbError", error.message || error || "Unknown error!");
        console.log(error);
        // Close dialog after error as well
        this.selectedPeriodDialog = false;
      } finally {
        this.isDataSavingloading = false;
      }
    },

    async getPeriodData(id) {
      this.loading = true;
      this.addeditdata = {};
      this.selectedgls = [];
      // this.selectednetwork = ""
      let period = new Date();
      try {
        if (!id) throw new Error('Please select network')
        if (this.selectedPeriodToGet !== null && this.selectedPeriodToGet !== "") {
          const date = new Date(this.selectedPeriodToGet);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
          period = `${year}-${month}`;
        } else period = `${period.getFullYear()}-${String(period.getMonth() + 1).padStart(2, "0")}`
        
        const dt = await this.getNetworkDetails({
          axios: this.axios,
          payload: { data: { period: period, network: id, cycletype: this.cycletype, statementtype: this.statementType } }
        });

        if (dt.data.status === "success") {
          this.newdata = dt.data.data || [];
          this.message = dt.data.message || 'No Data Found';
          if (this.newdata.length > 0) {
            // this.selectednetwork = id || "";
            this.addeditdata = this.newdata[0] || "";
            if (this.cycletype === "actual") {
              this.selectedgls = this.addeditdata.gls_actual || [];
              
              this.selectedsls = this.addeditdata.sls_actual || [];
            } else if (this.cycletype === "forecast") {
              this.selectedgls = this.addeditdata.gls_forecast || [];
              this.selectedsls = this.addeditdata.sls_forecast || [];
            }
            const glListResponse = await this.getGlList({ axios: this.axios, payload: { reporting_type: this.statementType } });
            if (glListResponse.data.status === "success") {
              if (glListResponse.data.data.length > 0) {
                this.gllist = {};
                // this.updateList(dt.data.data);
                this.getResult = glListResponse.data.data;
                this.setDisplayList(glListResponse.data.data);
              }
            } else throw new Error(glListResponse.data.message || 'Error reading data');
          } else {
            return { 'data': { 'status': 'success', 'data': [] } }
          }
        } else throw new Error(dt.data.message || "Error reading data");
      } catch (error) {
        this.$store.commit("sbError", error.message || error || "Unknown error!");
        console.log(error);
      } finally {
        // this.selectednetwork = id || "";
        this.loading = false;
      }
    },

    editData() {
      // this.addeditdialog=true;
      let td = {};
      for (const i of this.data) {
        if (i._id === this.selectednetwork) td = i;
      }
      if (this.cycletype === "actual") this.selectedgls = td.gls_actual || [];
      else if (this.cycletype === "forecast") this.selectedgls = td.gls_forecast || [];
      this.addeditdata = this.$nova.deepCopyJson(td);
    },
    selectAll() {
      this.selectedgls = [...this.allgls];
      // Update tab-specific storage immediately
      const tabKey = this.getCurrentTabKey();
      this.tabSelections[tabKey].gls = [...this.allgls];
    },
    unSelectAll() {
      this.selectedgls = [];
      this.selectedsls = [];
      // Update tab-specific storage immediately
      const tabKey = this.getCurrentTabKey();
      this.tabSelections[tabKey].gls = [];
      this.tabSelections[tabKey].sls = [];
    },
    expandColapseList(v) {
      if (this.expandedgls.indexOf(v) > -1) this.expandedgls.splice(this.expandedgls.indexOf(v), 1)
      else this.expandedgls.push(v);
      //this.pageItemsList(v);
    },
    storeTotal(len) {
      this.total = len;
      this.selectItem = [];
      this.pagecount = Math.ceil(this.total / this.perpage);
    },
    pageItemsList() {
      this.storeTotal((this.gllist || []).length)
      console.log(this.gllist['10000'])
      //return
      return this.gllist['10000'].slice((this.page - 1) * this.perpage, (this.page) * this.perpage);
    },
    selectedItems(value) {
      this.selectedgls = value;
    },
    async changesPeriodDate(network, cycletype, period) {
      let date = new Date(period);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      period = `${year}-${month}`;
      let errors = [];

      // Validate parameters and collect errors
      if (!network) errors.push("Network parameter is missing or empty.");
      if (!cycletype) errors.push("Cycletype parameter is missing or empty.");
      if (!period) errors.push("Period parameter is missing or empty.");

      // If any errors exist, show them and exit function
      if (errors.length > 0) {
        this.$store.commit("sbError", errors.join(" "));
        return;
      }

      this.loading = true;
      
      // Reset selections before loading new tab data to prevent cross-tab leakage
      const tabKeyBeforeReset = this.getCurrentTabKey();
      console.log(`[GLforMngtCommentary] changesPeriodDate: Resetting selections for tab ${tabKeyBeforeReset}, statementType=${this.statementType}`);
      console.log(`[GLforMngtCommentary] Before reset - selectedgls: ${this.selectedgls.length}, savedGlsStatus: ${this.savedGlsStatus.length}`);
      
      this.selectedgls = [];
      this.selectedsls = [];
      this.savedGlsStatus = [];
      this.savedSlsStatus = [];
      
      console.log(`[GLforMngtCommentary] After reset - selectedgls: ${this.selectedgls.length}`);

      try {
        // Make the first API call
        const response = await this.getNetworkDetails({
          axios: this.axios,
          payload: { data: { period, network, cycletype, statementtype: this.statementType } }
        });

        if (response.data.status !== "success") {
          throw new Error(response.data.message || "Error reading data");
        }

        // Check for stale request
        if (this.selectednetwork !== network) {
            console.log('Ignoring stale response for network:', network);
            return;
        }

        this.newdata = response.data.data || [];
        this.message = response.data.message || "No Data Found";

        if (this.newdata.length > 0) {
          // Removed redundant assignment to prevent infinite loop
          this.addeditdata = this.newdata[0] || "";

          if (cycletype === "actual") {
            this.selectedgls = this.addeditdata.gls_actual || [];
            this.selectedsls = this.addeditdata.sls_actual || [];
            this.savedGlsStatus = [...(this.addeditdata.gls_actual || [])];
            this.savedSlsStatus = [...(this.addeditdata.sls_actual || [])];
          } else if (cycletype === "forecast") {
            this.selectedgls = this.addeditdata.gls_forecast || [];
            this.selectedsls = this.addeditdata.sls_forecast || [];
            this.savedGlsStatus = [...(this.addeditdata.gls_forecast || [])];
            this.savedSlsStatus = [...(this.addeditdata.sls_forecast || [])];
          }
          
          console.log(`[GLforMngtCommentary] API returned data for ${this.statementType}: selectedgls=${this.selectedgls.length}`);
          
          // Update tab-specific selections storage
          this.updateTabSavedStatus(this.selectedgls, this.selectedsls);
          const glListResponse = await this.getGlList({ axios: this.axios, payload: { reporting_type: this.statementType } });

          if (glListResponse.data.status !== "success") {
            throw new Error(glListResponse.data.message || "Error reading data");
          }

          if (glListResponse.data.data.length > 0) {
            this.gllist = {};
            this.setDisplayList(glListResponse.data.data);
          } else {
            throw new Error("GL list is empty.");
          }
        } else {
          this.$store.commit("sbError", "No network data found.");
        }
      } catch (err) {
        // Handle API errors
        this.$store.commit("sbError", err.message || "Unknown error!");
        console.error(err);
      } finally {
        // Ensure loading is set to false only if we are still processing the same network
        if (this.selectednetwork === network) {
          this.loading = false;
        }
      }

      console.log("All parameters are valid.");
    },
  },
  watch: {
    unsavedChangesDialog(newVal) {
      // If dialog closed without confirmation, cancel the pending switch
      if (!newVal && this.pendingTabIndex !== null) {
        this.pendingTabIndex = null;
      }
    },
    activeStatementTab(newTab) {
      const nextType = newTab === STATEMENT_TAB_INDEX.BALANCE_SHEET
        ? STATEMENT_TYPES.BALANCE_SHEET
        : STATEMENT_TYPES.PROFIT_AND_LOSS;
      if (this.statementType !== nextType) {
        this.handleStatementTypeChange(nextType);
      }
    },
    selectednetwork() {
      // Skip watcher during initial data load to prevent duplicate API calls
      if (this.isInitialDataLoad) {
        return;
      }
      
      if (this.selectednetwork) {
        this.changesPeriodDate(this.selectednetwork, this.cycletype, this.selectedPeriodToGet);
      }


      // let period = `${this.selectedPeriodToGet.getFullYear()}-${String(this.selectedPeriodToGet.getMonth() + 1).padStart(2, "0")}`
      // console.log(this.selectednetwork,this.cycletype,  this.selectedPeriodToGet);

      // this.changesPeriodDate(this.selectednetwork,this.cycletype, this.selectedPeriodToGet);
    },
    cycletype() {

      if (this.cycletype === "actual") this.selectedgls = this.addeditdata.gls_actual || [];
      else if (this.cycletype === "forecast") this.selectedgls = this.addeditdata.gls_forecast || [];

      //  let date = new Date(this.selectedPeriodToGet);
      //   let year = date.getFullYear();
      //   let month = date.getMonth()+1;
      //   this.selectedPeriodToGet = `${year}-${month}`;
      //   console.log(this.selectedPeriodToGet)
      if (this.selectednetwork) {
        this.changesPeriodDate(this.selectednetwork, this.cycletype, this.selectedPeriodToGet);
      }
      // this.changesPeriodDate(this.selectednetwork,this.cycletype, this.selectedPeriodToGet);
      // this.updateList();
    },
    selectedPeriodToGet(old,newVal) {
      console.log(old,newVal, this.selectednetwork,"WATCH PERIOD");
      
      const regex = /^\d{4}-\d{2}$/;
      if (this.selectedPeriodToGet !== '' && regex.test(this.selectedPeriodToGet) && this.selectednetwork) {
        let date = new Date(this.selectedPeriodToGet);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        this.selectedPeriodToGet = `${year}-${month}`;
        this.changesPeriodDate(this.selectednetwork, this.cycletype, `${year}-${month}`);
      }
    }
  },
  computed: {
    statementTabIndex() {
      return STATEMENT_TAB_INDEX;
    },
    visibleItems() {
      const naChildSet = new Set((this.gllist['NA'] || []).map(i => i.code));
      return this.flattenTree(this.getResult).filter((item) =>
        this.expandedIds.includes(item.code) &&
        item.code !== 'NA' &&
        !naChildSet.has(item.code)
      );
    },
    ungroupedGlItems() {
      // setDisplayList already computes isnewgl on each item in gllist['NA']
      return (this.gllist['NA'] || []).map(item => ({ ...item, level: 0, glnew: item.isnewgl || false }));
    },
    getParentList: {
      get() {
        let dt = [...this.gllist['primary'] || []];
        // if(!this.isNewList){
        //   dt = [...dt, ...(this.gllist['new'] || [])];
        // }
        dt.push({ code: "NA", name: "Ungrouped: Other sub-schedules and further Analysis Accounts" })
        return dt;
      },
      cache: false
    },
  }
}
</script>

<style scoped>
.gl-for-mngt-commentary__shell {
  border-radius: var(--radius-12);
  background-color: transparent;
}

.gl-for-mngt-commentary__tabs {
  margin-bottom: -1px;
}

.folder-tab {
  padding: 8px 16px;
  background-color: var(--grey-white);
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  color: var(--grey-900);
  transition: background-color 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              color 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 400;
  margin-bottom: -10px;
}

.folder-tab.active {
  background-color: var(--grey-white);
  border-bottom: var(--border-sm) solid var(--grey-white);
  color: var(--color-primary-base);
  font-weight: 600;
  z-index: 3;
  margin-bottom: 0px;
  border-top: var(--border-sm) solid var(--grey-100);
  border-left: var(--border-sm) solid var(--grey-100);
  border-right: var(--border-sm) solid var(--grey-100);
}

transition-list * {
  transition: all 0.5s ease-in-out;
}


.node-container {
  height: 50px;
  margin-right: var(--space-2xs);
}

.node-label {
  top: 0;
  bottom: 0;
  left: var(--space-xs);
  /* width: 1px; */
  /* background-color: #000000; */
  display: block;
  /* Important for visibility */
  height: 100%;
  /* Make sure it stretches */
  content: "";
}

.childlevele-0 {
  width: 0.5px;
  background-color: var(--grey-800);

}


.v-table-color {
  margin-bottom: 50px;

}
</style>
